// extracted by mini-css-extract-plugin
export default {"icon":"icon_icon__ufH6H","small":"icon_small__Uys-X","medium":"icon_medium__oN-RJ","large":"icon_large__+SykR"};